import * as Yup from "yup";
import {
  requiredString,
  emailField,
  // emailFieldRequired,
  // passwordField,
  passwordFieldRequired,
  phoneNumberField,
  phoneNumberFieldRequired,
  // postalCodeField,
  postalCodeFieldRequired,
  requiredFile,
  aadharNumberFieldRequired,
} from "./validationRules";

export const fundingAgencyDetailsValidationSchema = Yup.object().shape({
  agencyName: requiredString("Agency Name"),
  bcOrOwn: requiredString("BC/OWN"),
  fundingAgencyCode: Yup.string().nullable(),
  // Business Loan fields - all optional
  blProcessingFeePercentage: Yup.number().nullable(),
  blProcessingFeeEnabled: Yup.boolean().nullable(),
  blInsurancePercentage: Yup.number().nullable(),
  blInsuranceEnabled: Yup.boolean().nullable(),
  blInsuranceAbove199999Percentage: Yup.number().nullable(),
  blInsuranceAbove199999Enabled: Yup.boolean().nullable(),
  blSecurityDepositPercentage: Yup.number().nullable(),
  blSecurityDepositEnabled: Yup.boolean().nullable(),
  blRevenueInterestPercentage: Yup.number().nullable(),
  blRevenueInterestEnabled: Yup.boolean().nullable(),
  blGstPercentage: Yup.number().nullable(),
  blGstEnabled: Yup.boolean().nullable(),
  blRateOfInterest: Yup.number().nullable(),
  blRateOfInterestEnabled: Yup.boolean().nullable(),
  blRevenueProcessingFeePercentage: Yup.number().nullable(),
  blRevenueProcessingFeeEnabled: Yup.boolean().nullable(),
  // JLG Loan fields - all optional
  jlgProcessingFeePercentage: Yup.number().nullable(),
  jlgProcessingFeeEnabled: Yup.boolean().nullable(),
  jlgInsurancePercentage: Yup.number().nullable(),
  jlgInsuranceEnabled: Yup.boolean().nullable(),
  jlgInsuranceAbove199999Percentage: Yup.number().nullable(),
  jlgInsuranceAbove199999Enabled: Yup.boolean().nullable(),
  jlgSecurityDepositPercentage: Yup.number().nullable(),
  jlgSecurityDepositEnabled: Yup.boolean().nullable(),
  jlgRevenueInterestPercentage: Yup.number().nullable(),
  jlgRevenueInterestEnabled: Yup.boolean().nullable(),
  jlgGstPercentage: Yup.number().nullable(),
  jlgGstEnabled: Yup.boolean().nullable(),
  jlgRateOfInterest: Yup.number().nullable(),
  jlgRateOfInterestEnabled: Yup.boolean().nullable(),
  jlgRevenueProcessingFeePercentage: Yup.number().nullable(),
  jlgRevenueProcessingFeeEnabled: Yup.boolean().nullable(),
  // GPL Loan fields - all optional
  gplProcessingFeePercentage: Yup.number().nullable(),
  gplProcessingFeeEnabled: Yup.boolean().nullable(),
  gplInsurancePercentage: Yup.number().nullable(),
  gplInsuranceEnabled: Yup.boolean().nullable(),
  gplInsuranceAbove199999Percentage: Yup.number().nullable(),
  gplInsuranceAbove199999Enabled: Yup.boolean().nullable(),
  gplSecurityDepositPercentage: Yup.number().nullable(),
  gplSecurityDepositEnabled: Yup.boolean().nullable(),
  gplRevenueInterestPercentage: Yup.number().nullable(),
  gplRevenueInterestEnabled: Yup.boolean().nullable(),
  gplGstPercentage: Yup.number().nullable(),
  gplGstEnabled: Yup.boolean().nullable(),
  gplRateOfInterest: Yup.number().nullable(),
  gplRateOfInterestEnabled: Yup.boolean().nullable(),
  gplRevenueProcessingFeePercentage: Yup.number().nullable(),
  gplRevenueProcessingFeeEnabled: Yup.boolean().nullable(),
  // Daily Loan (DL). Additive - no rule above is changed.
  dlRateOfInterest: Yup.number().nullable(),
  dlRateOfInterestEnabled: Yup.boolean().nullable(),
  dlProcessingFeePercentage: Yup.number().nullable(),
  dlProcessingFeeEnabled: Yup.boolean().nullable(),
  dlGstPercentage: Yup.number().nullable(),
  dlGstEnabled: Yup.boolean().nullable(),
  dlSecurityDepositPercentage: Yup.number().nullable(),
  dlSecurityDepositEnabled: Yup.boolean().nullable(),
  dlInsurancePercentage: Yup.number().nullable(),
  dlInsuranceEnabled: Yup.boolean().nullable(),
  dlRevenueInterestPercentage: Yup.number().nullable(),
  dlRevenueInterestEnabled: Yup.boolean().nullable(),
  dlRevenueProcessingFeePercentage: Yup.number().nullable(),
  dlRevenueProcessingFeeEnabled: Yup.boolean().nullable(),
});

export const dailyGoldRateDetailsValidationSchema = Yup.object().shape({
  rateDate: requiredString("Rate"),
  goldRate22k: requiredString("Date"),
});
